/**
 * `/admin/tardiness-policies` — la rotta storica delle policy ritardi. Resta per i segnalibri e porta
 * dove si configurano dal 03-11-2026, unico posto: «Regole di lavoro → Ritardi».
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/tardiness-policies')({
  component: () => <Navigate to="/organization/work-rules" search={{ section: 'tardiness' }} replace />,
});
